import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { Dialog } from 'vant';
import 'vant/lib/index.css';
//导入md5.js
import MD5 from "js-md5"
//将md5转换成vue原型：
Vue.prototype.md5 = MD5


Vue.use(Dialog);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
